import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql, PayloadError } from "relay-runtime"
import {
  ImportAtossFileInput,
  useImportAtossFileMutation as useImportAtossFileMutationType,
  useImportAtossFileMutation$data,
} from "@/modules/admin/capacity/services/__generated__/useImportAtossFileMutation.graphql"

const mutation = graphql`
  mutation useImportAtossFileMutation($input: ImportAtossFileInput!) {
    importAtossFile(input: $input) {
      atossFileUpload {
        id
        uploadedAt
        uploadedBy
        fileHash
        processedStatus
        processedError
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export function useImportAtossFileMutation(): [
  (
    input: ImportAtossFileInput,
    handleComplete?: ((response: useImportAtossFileMutation$data, errors: PayloadError[] | null) => void) | undefined,
    handleError?: ((error: Error) => void) | undefined,
  ) => void,
  boolean,
] {
  const [commit, areMutationsInFlight] = useMutation<useImportAtossFileMutationType>(mutation)

  return [
    useCallback(
      (
        input: ImportAtossFileInput,
        handleComplete?: (response: useImportAtossFileMutation$data, errors: PayloadError[] | null) => void,
        handleError?: (error: Error) => void,
      ) => {
        commit({
          variables: {
            input: {
              file: input.file,
            },
          },
          onCompleted: handleComplete,
          onError: handleError,
        })
      },
      [commit],
    ),
    areMutationsInFlight,
  ]
}
